import { Fragment, useMemo } from "react";
import { HeaderMall9 } from "../../../../../publicComponent/Header";
import Navigator from "../../../../../publicComponent/h5/Navigator";
import TabsMall9 from "../../../../../publicComponent/Tabs/TabMall9";
import { useEffect, useState } from "react";
import OrderListContext, {
  OrderListController,
  useOrderListContext,
} from "../../../../../reducer/moduleReducer/my/orderList";
import { getOrderStatus } from "../../../../../utils";
import Pagination from "../../../../../publicComponent/Pagination";
import Buffer from "../../../../../publicComponent/Buffer";
import { getI18n, useTranslation } from "react-i18next";
import { useQueryParam } from "../../../../../hooks";

function THead() {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-12 gap-3 px-[18px] py-[12px] mdmax:hidden">
      <div className="col-span-9 grid grid-cols-9">
        <p className="text-[14px] font-bold col-span-5">{t("商品信息")}</p>
        <p className="text-[14px] font-bold col-span-1 text-center">
          {t("单价")}
        </p>
        <p className="text-[14px] font-bold col-span-1 text-center">
          {t("数量")}
        </p>
        <p className="text-[14px] font-bold col-span-2 text-center">
          {t("商品总价")}
        </p>
      </div>
      <p className="text-[14px] font-bold col-span-1 text-center">
        {t("订单状态")}
      </p>
      <p className="text-[14px] font-bold col-span-2 text-center">
        {t("操作")}
      </p>
    </div>
  );
}

function OrderCard({ item }) {
  const {
    gotoOrderDetail,
    cancelOrderHandle,
    gotoOrderQRCode,
    gotoOrderComment,
    receivedOrder,
    getExpressDetail,
    showUploadVouchers,
  } = OrderListController();
  const { t } = useTranslation();
  const lang = getI18n().language;

  return (
    <>
      <div className="mb-[16px] mdmax:hidden">
        <div className="flex px-[18px] py-[12px] border-t border-[#ddd] bg-[#f4f4f6] ">
          <p className="text-[14px] font-bold">
            {t("订单号：")} {item.orderNo}
          </p>
          <p className="text-[14px] w-[180px] ml-[30px]">{item.createTime}</p>
          <p
            style={{
              color: !item.payMeVoucher && !item.fpsVoucher ? "red" : "#000",
            }}
          >
            {item.payType === "5"
              ? item.payMeVoucher
                ? t("已上传凭证")
                : t("暂未上传凭证")
              : item.payType === "6"
              ? item.fpsVoucher
                ? t("已上传凭证")
                : t("暂未上传凭证")
              : ""}
          </p>
        </div>
        <div className="grid grid-cols-12 gap-3 px-[18px] py-[12px] pr-[20px]">
          <div className="col-span-8 grid grid-cols-8">
            {item.productList &&
              item.productList.map((goods, i) => (
                <div className="col-span-8 grid grid-cols-8 pb-[15px]" key={i}>
                  <div className="col-span-4 flex">
                    <div
                      className="w-[120px] h-[120px] flex-none bg-[#444] rounded-[10px] overflow-hidden"
                      style={{ fontSize: 0 }}
                    >
                      <img
                        src={goods.imgPathView}
                        style={{ width: "100%", height: "100%" }}
                      />
                    </div>
                    <div className="pt-[5px] ml-[20px] flex-grow">
                      <p className="text-[14px] mb-[8px]">
                        {lang === 'en'?goods.productEnName:goods.productName}
                      </p>
                      <p className="text-[#999]">{goods.specName}</p>
                      {/*<p className="text-[#999]">15ml</p>*/}
                    </div>
                  </div>
                  <div className="col-span-1 pt-[5px] text-center">
                    ${goods.salePrice}
                  </div>
                  <div className="col-span-1 pt-[5px] text-center">
                    x{goods.productQty}
                  </div>
                  <div className="col-span-2 pt-[5px] text-center">
                    <h2 className="text-[#333] text-[16px] font-bold">
                      ${goods.payPrice}
                    </h2>
                    {goods.transportPreferPrice &&
                      goods.transportPreferPrice > 0 && (
                        <p className="text-[#999]">
                          （包含快递费${goods.transportPreferPrice}）
                        </p>
                      )}
                  </div>
                </div>
              ))}
          </div>

          <div className="grid grid-cols-4 col-span-4">
            <div className="pt-[5px] col-span-1 text-center">
              {t(getOrderStatus(item.orderStatus))}
            </div>
            <div className="pt-[5px] col-span-1 text-center">
              {item.transportType === "1" ? t("到店自提") : t("物流配送")}
            </div>
            <div className="pt-[5px] col-span-2 divide-x divide-[#999] text-center">
              <a
                className="link px-[12px]"
                onClick={() => gotoOrderDetail(item)}
              >
                {t("查看订单")}
              </a>

              {item.orderStatus === 8 && Number(item.transportType) === 1 && (
                <a
                  onClick={() => gotoOrderQRCode(item)}
                  className="link px-[12px]"
                >
                  {t("核销码")}
                </a>
              )}

              {item.orderStatus === 3 && (
                <a
                  onClick={() => receivedOrder(item)}
                  className="link px-[12px]"
                >
                  {t("确认收货")}
                </a>
              )}

              {[3].includes(item.orderStatus) && item.expressCode && (
                <a
                  onClick={() => getExpressDetail(item)}
                  className="link px-[12px]"
                >
                  {t("查看物流")}
                </a>
              )}

              {item.orderStatus === 9 && (
                <a
                  onClick={() => cancelOrderHandle(item)}
                  className="link px-[12px]"
                >
                  {t("删除订单")}
                </a>
              )}

              {item.orderStatus === 0 && (
                <a
                  onClick={() => cancelOrderHandle(item)}
                  className="link px-[12px]"
                >
                  {t("取消订单")}
                </a>
              )}

              {item.orderStatus === 1 && (
                <a
                  onClick={() => gotoOrderComment(item)}
                  className="link px-[12px]"
                >
                  {t("评价")}
                </a>
              )}

              {(item.payType === "5" || item.payType === "6") &&
                item.orderStatus === 0 && (
                  <a
                    onClick={() =>
                      showUploadVouchers({
                        payType: item.payType,
                        orderId: item.orderId,
                        voucher: item.fpsVoucher || item.payMeVoucher,
                      })
                    }
                    className="link px-[12px]"
                  >
                    {t("上传凭证")}
                  </a>
                )}
            </div>
          </div>
        </div>
      </div>

      <div
        className="mx-[3%] mt-[15px] md:hidden rounded-[12px] mdmax:bg-white"
        style={{ boxShadow: "0 6px 18px rgba(0,0,0,.1)" }}
      >
        <div className="flex py-[12px] px-[15px] border-b border-[#eee] justify-between">
          <p>
            {t("订单号：")} {item.orderNo}
          </p>
          <p>{t(getOrderStatus(item.orderStatus))}</p>
        </div>
        <div className="p-[15px]">
          {item.productList &&
            item.productList.map((goods, i) => (
              <Fragment key={i}>
                <div className="flex mb-[15px]">
                  <div className="w-[80px] h-[80px] bg-white flex-none mr-[15px] rounded-[5px] overflow-hidden">
                    <img
                      src={goods.imgPathView}
                      style={{ width: "100%", height: "100%" }}
                    />
                  </div>
                  <div>
                    <p className="text-[14px] line-clamp-2">
                      {lang === 'en'?goods.productEnName:goods.productName}
                    </p>
                    <p className="text-[14px] text-[#666]">
                      ${goods.salePrice} x{goods.productQty}
                    </p>
                    <p className="text-[12px] text-[#666]">{goods.specName}</p>
                  </div>
                </div>
              </Fragment>
            ))}
          <div className="text-right">
            <a
              className="text-[14px] border border-[#ddd] py-[5px] px-[15px] rounded-full"
              onClick={() => gotoOrderDetail(item)}
            >
              {t("查看订单")}
            </a>

            {item.orderStatus === 8 && Number(item.transportType) === 1 && (
              <a
                className="text-[14px] border border-[#ddd] py-[5px] px-[15px] rounded-full  ml-[10px]"
                onClick={() => gotoOrderQRCode(item)}
              >
                {t("核销码")}
              </a>
            )}

            {item.orderStatus === 3 && (
              <a
                className="text-[14px] border border-[#ddd] py-[5px] px-[15px] rounded-full"
                onClick={() => receivedOrder(item)}
              >
                {t("确认收货")}
              </a>
            )}

            {[1, 3, 4].includes(item.orderStatus) && (
              <a className="text-[14px] ml-[10px] border border-[#ddd] py-[5px] px-[15px] rounded-full">
                {t("查看物流")}
              </a>
            )}

            {item.orderStatus === 9 && (
              <a className="text-[14px] ml-[10px] border border-[#ddd] py-[5px] px-[15px] rounded-full">
                {t("删除订单")}
              </a>
            )}

            {item.orderStatus === 0 && (
              <a
                className="text-[14px] border border-[#ddd] py-[5px] px-[15px] rounded-full ml-[10px]"
                onClick={() => cancelOrderHandle(item)}
              >
                {t("取消订单")}
              </a>
            )}

            {item.orderStatus === 1 && (
              <a
                onClick={() => gotoOrderComment(item)}
                className="text-[14px] border border-[#ddd] py-[5px] px-[15px] rounded-full  ml-[10px]"
              >
                {t("评价")}
              </a>
            )}

            {(item.payType === "5" || item.payType === "6") &&
              item.orderStatus === 0 && (
                <a
                  onClick={() =>
                    showUploadVouchers({
                      payType: item.payType,
                      orderId: item.orderId,
                      voucher: item.fpsVoucher || item.payMeVoucher,
                    })
                  }
                  className="text-[14px] border border-[#ddd] py-[5px] px-[15px] rounded-full  ml-[10px]"
                >
                  {t("上传凭证")}
                </a>
              )}
          </div>
        </div>
      </div>
    </>
  );
}

function OrderListWrap() {
  const { getOrderList, setTabsActive } = OrderListController();
  const { state } = useOrderListContext();
  const [status] = useQueryParam("status");
  const { orderList, statusTabs, tabActive, query, loading, total } = state;

  const isNoMore = useMemo(() => {
    return state.orderList.length === state.total;
  }, [orderList, total]);
  const { t } = useTranslation();

  useEffect(() => {
    if (status) {
      setTabsActive(status);
    } else {
      getOrderList({ orderStatus: status });
    }
  }, []);

  return (
    <Navigator.container className="container-center">
      <h1 className="font-bold pt-[20px] text-[24px] pb-[15px] mdmax:hidden">
        {t("我的订单")}
      </h1>
      <TabsMall9
        fixed
        tabs={statusTabs}
        active={tabActive}
        tabsActiveColor={"#ECBC40"}
        style={{ marginBottom: 0, borderBottom: 0 }}
        onChange={setTabsActive}
      />
      <div className="relative mdmax:pt-[30px] mdmax:bg-[#f4f4f6]">
        <Buffer.Loading loading={loading} />
        {state.orderList.length > 0 ? (
          <>
            {/*<THead/>*/}
            <div className="pb-[12px] md:border-b border-[#d1d1d1] md:mb-[25px]">
              {orderList.map((item, i) => (
                <OrderCard item={item} key={i} />
              ))}
            </div>
            <Pagination
              total={total}
              current={query.page}
              onChange={(page) => getOrderList({ page })}
              className="md:mb-[100px]"
            />
          </>
        ) : (
          <Buffer.Empty content={t("暂无相关订单")} />
        )}
      </div>
    </Navigator.container>
  );
}

export default function OrderList() {
  return (
    <>
      <HeaderMall9 />
      <Navigator title="我的订单" goback noBorder />
      <OrderListContext>
        <OrderListWrap />
      </OrderListContext>
    </>
  );
}
